import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import store from "../catalog/app/redux/store";
import {  Routes, Route } from "react-router-dom";
import * as Actions from "../catalog/app/redux/actions";
//import i18n from "./config/i18n";


import Login from "./login";
import RefreshPwd from "./refresh-pwd";


const LoginRouter = () => {


  return (
    <Provider store={store}>
            
            <Routes>
              <Route path="/" element={<Login />} />

              <Route path="/refpwd/:token" element={<RefreshPwd />} />

            </Routes>
    </Provider>
  );
};

export default LoginRouter;
